import { useContext } from 'react';

import { ScopesContext } from 'context/ScopesContext';

export const useScopes = () => useContext(ScopesContext);
